<template>
  <div class="tongket-container">
    <div class="tongket-header">
      <button @click="goToPreviousMonth" class="month-arrow">◄</button>
      <span class="month-label">THÁNG {{ currentMonth.toString().padStart(2, '0') }}/{{ currentYear }}</span>
      <button @click="goToNextMonth" class="month-arrow">►</button>
    </div>
    <div class="tongket-subtitle">
      TỔNG QUỸ HẢO TÂM: {{ totalAmount.toLocaleString() }}đ
    </div>
    <div class="tongket-title">Top các nhà tài trợ của tháng</div>
    <div v-if="loading" class="loading-box">
      <div class="loading-spinner"></div>
    </div>
    <ul v-else class="tongket-list">
      <li v-for="(player, index) in players" :key="player.id" class="tongket-item">
        <div class="rank">#{{ index + 1 }}</div>
        <img
          :src="player.avatar"
          alt="avatar"
          class="avatar"
          :class="{ 'top-avatar': index === 0 }"
        />
        <div class="name">
          {{ player.name }}
          <span v-if="index === 0" class="crown">👑</span>
        </div>
        <div class="amount">{{ player.amount.toLocaleString() }}đ</div>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  name: "TongKet",
  data() {
    const now = new Date();
    const thisMonth = now.getMonth() + 1;
    const thisYear = now.getFullYear();
    return {
      thisMonth,
      thisYear,
      currentMonth: thisMonth,
      currentYear: thisYear,
      players: [],
      loading: true,
    };
  },
  methods: {
    goToPreviousMonth() {
      if (
        this.currentYear === this.thisYear &&
        this.currentMonth > this.thisMonth - 2
      ) {
        this.currentMonth--;
        this.fetchRanking();
      }
    },
    goToNextMonth() {
      if (
        this.currentYear === this.thisYear &&
        this.currentMonth < this.thisMonth
      ) {
        this.currentMonth++;
        this.fetchRanking();
      }
    },
    async fetchRanking() {
      this.loading = true;
      const url = `https://script.google.com/macros/s/AKfycbz4wD73DLbVeAuu1IJlFw-_TitiaU0LUUGYKFRG3_GlGmwUwaqjkbrDza0P4kMAe3lNGg/exec?action=getMonthlyRanking&month=${this.currentMonth}&year=${this.currentYear}`; //APIv1.2
      try {
        const res = await fetch(url);
        const data = await res.json();
        if (Array.isArray(data)) {
          this.players = data.map(player => ({
            id: player.playerId,
            name: player.playerName,
            avatar: player.playerAvatar,
            amount: Math.floor(Number(player.total) || 0) * 1000
          }));
        } else {
          console.error("❌ Dữ liệu players API không hợp lệ:", data);
          this.players = [];
        }
      } catch (err) {
        console.error("❌ Lỗi khi fetch dữ liệu xếp hạng:", err);
        this.players = [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchRanking();
    },
  computed: {
      totalAmount() {
        return this.players.reduce((sum, p) => sum + (p.amount || 0), 0);
      }
  },
};
</script>


<style scoped>
.tongket-container {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.tongket-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  font-weight: bold;
  font-size: 18px;
}

.month-arrow {
  background: none;
  border: none;
  font-size: 20px;
  padding: 0 12px;
  cursor: pointer;
}

.month-label {
  color: #222;
  font-size: 16px;
}

.tongket-title {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 12px;
}

.tongket-list {
  list-style: none;
  padding: 0;
}

.tongket-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid #cecece;
  border-radius: 999px;
  margin-bottom: 8px;
  background-color: #fff;
}

.loading-box {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 4px solid #ccc;
  border-top: 4px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.rank {
  width: 30px;
  font-weight: bold;
  color: #444;
  padding-left: 5px;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0 10px;
}

.name {
  flex: 1;
  font-size: 15px;
  font-weight: 500;
  color: #222;
}

.amount {
  font-size: 16px;
  font-weight: bold;
  color: #0fa20d;
  padding-right: 10px;
}

.top-avatar {
  border: 2px solid gold;
  padding: 1px;
}

.crown {
  margin-left: 6px;
  font-size: 16px;
}

.tongket-subtitle {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color: #29b10e;
  margin-bottom: 12px;
}
</style>